export const environment = {
    production: false,
    api_url: 'https://betaapi.helpmulte24.it/api/v1'
};
